module.exports = __webpack_public_path__ + "img/주력.efe31a52.svg";